import { NgModule } from '@angular/core';
import { SloanUserChangePasswordFormModule } from './change-password-form/user-change-password-form.module';
import { SloanOrganizationCardModule } from './card/card.module';

@NgModule({
  imports: [SloanUserChangePasswordFormModule, SloanOrganizationCardModule],
})
export class SloanOrganizationComponentsModule {}
